import PropTypes from 'prop-types';

import PropTypeStatus from './PropTypeStatus';

export default {
  name: PropTypes.string.isRequired,
  tokenLabel: PropTypes.string.isRequired,
  tokenAddress: PropTypes.string.isRequired,
  formattedTokensPerCode: PropTypes.string.isRequired,
  formattedTotalTokens: PropTypes.string,
  transactionHash: PropTypes.string,
  id: PropTypes.string,
  timestamp: PropTypes.number,
  ...PropTypeStatus,
};



// WEBPACK FOOTER //
// ./src/utilities/propTypes/PropTypeCampaign.js